import React from "react";
import { Link } from "react-router-dom";
import {
  FaHeart,
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { useLanguage } from "../context/LanguageContext";

const Footer = () => {
  const { language } = useLanguage();

  const t = {
    English: {
      quickLinks: "Quick Links",
      about: "About Us",
      success: "Success Stories",
      contact: "Contact Us",
      blog: "Blog",
      careers: "Careers",
      help: "Help & Support",
      liveSupport: "24x7 Live Support",
      feedback: "Feedback",
      faqs: "FAQs",
      safety: "Safety Tips",
      report: "Report Misuse",
      legal: "Legal",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      cookie: "Cookie Policy",
      refund: "Refund Policy",
      rights: "All rights reserved.",
      madeWith: "Made with",
    },
    Tamil: {
      quickLinks: "விரைவு இணைப்புகள்",
      about: "எங்களைப் பற்றி",
      success: "வெற்றிக் கதைகள்",
      contact: "தொடர்பு கொள்ள",
      blog: "வலைப்பதிவு",
      careers: "வேலைவாய்ப்புகள்",
      help: "உதவி & ஆதரவு",
      liveSupport: "24x7 நேரடி ஆதரவு",
      feedback: "கருத்து",
      faqs: "கேள்வி பதில்கள்",
      safety: "பாதுகாப்பு குறிப்புகள்",
      report: "தவறான பயன்பாட்டைப் புகாரளிக்கவும்",
      legal: "சட்டபூர்வமானவை",
      terms: "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      privacy: "தனியுரிமைக் கொள்கை",
      cookie: "குக்கீ கொள்கை",
      refund: "பணம் திரும்பப்பெறும் கொள்கை",
      rights: "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
      madeWith: "இந்தியாவில்",
    },
  };

  const txt = t[language];

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8 font-sans">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-6 text-center md:text-left">
            <Link to="/" className="inline-flex items-center">
              <img
                src="/logo1.png"
                alt="ST MatchZone Logo"
                className="h-14 w-auto object-contain rounded-lg"
              />
            </Link>

            <p className="text-gray-400 leading-relaxed text-sm">
              {language === "English"
                ? "The most trusted matrimony brand in India. We believe in providing a secure, easy-to-use and convenient matchmaking experience to our customers."
                : "இந்தியாவின் மிகவும் நம்பிக்கையான திருமண சேவை. பாதுகாப்பான மற்றும் எளிதான திருமண அனுபவத்தை வழங்குவதில் நாங்கள் உறுதியாக உள்ளோம்."}
            </p>
            <div className="flex justify-center md:justify-start space-x-4">
              {[FaFacebook, FaTwitter, FaInstagram, FaLinkedin].map(
                (Icon, i) => (
                  <a
                    key={i}
                    href="#"
                    className="w-10 h-10 rounded-full bg-gray-800 flex items-center justify-center text-gray-400 hover:bg-rose-600 hover:text-white transition-all"
                  >
                    <Icon />
                  </a>
                )
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h4 className="text-lg font-bold mb-6 text-rose-500">
              {txt.quickLinks}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about-us"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.about}
                </Link>
              </li>
              <li>
                <Link
                  to="/success-stories"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.success}
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.contact}
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.blog}
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/careers"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.careers}
                </Link>
              </li> */}
              <li>
                <span className="text-gray-400 hover:text-rose-500 transition-colors text-sm cursor-default">
                  {txt.careers}
                </span>
              </li>
            </ul>
          </div>

          {/* Help & Support */}
          <div className="text-center md:text-left text-rose-500">
            <h4 className="text-lg font-bold mb-6">{txt.help}</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/live-support"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.liveSupport}
                </Link>
              </li>
              <li>
                <Link
                  to="/feedback"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.feedback}
                </Link>
              </li>
              <li>
                <Link
                  to="/faqs"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.faqs}
                </Link>
              </li>
              <li>
                <Link
                  to="/safety"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.safety}
                </Link>
              </li>
              <li>
                <Link
                  to="/report"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.report}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="text-center md:text-left text-rose-500">
            <h4 className="text-lg font-bold mb-6">{txt.legal}</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/terms"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.terms}
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.privacy}
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.cookie}
                </Link>
              </li>
              <li>
                <Link
                  to="/refund"
                  className="text-gray-400 hover:text-rose-500 transition-colors text-sm"
                >
                  {txt.refund}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-500 text-sm gap-4">
          <p className="text-center md:text-left">
            © {new Date().getFullYear()} ST MatchZone. {txt.rights}
          </p>

          <p className="text-center md:text-right">
            Designed by{" "}
            <a
              href="https://softyetech.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-gray-300 hover:text-rose-500 transition-colors"
            >
              Softye Technologies
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
